/*  ========================================================================
    # Hooks - Use Projects API
    ========================================================================  */

import { useEffect, useState } from 'react';

const useProjectsApi = params => {
  const [loadingProjects, setLoadingProjects] = useState(true);
  const [projects, setProjects] = useState([]);
  const [projectsCount, setProjectsCount] = useState(0);
  const paramsString = new URLSearchParams();

  const getProjects = async () => {
    setLoadingProjects(true);

    for (const [key, value] of Object.entries(params)) {
      if (key === 'categories') {
        if (value !== '' && value.length > 0) {
          paramsString.append('247grad_project_category', value);
        }
      } else {
        paramsString.append(key, value);
      }
    }

    try {
      const response = await fetch(`/wp-json/wp/v2/247grad_project?${paramsString.toString()}`);

      if (response.status !== 200) {
        throw new Error(await response.text());
      }

      const projects = await response.json();
      const mappedProjects = projects.map(project => ({
        id: project.id,
        customer: project.acf?.customer,
        projectName: project.acf?.project_name,
        excerpt: project.excerpt.rendered.replace('<p>', '').replace('</p>', ''),
        url: project.link,
        image: { sizes: project.featured_image, alt: project.acf?.project_name }
      }));

      setLoadingProjects(false);
      setProjectsCount(parseInt(response.headers.get('X-WP-Total'), 10));
      setProjects(mappedProjects);
    } catch (error) {
      setLoadingProjects(false);
      console.log(error); // eslint-disable-line
    }
  };

  useEffect(() => {
    getProjects();
  }, [params.per_page, params.page, params.categories, params.search, params.offset]);

  return { loadingProjects, projects, projectsCount };
};

export default useProjectsApi;
